// index.ts
import editorPlugin from "./plugin";
import renderElem from "./render-elem";
import elemToHtml from "./elem-to-html";
import parseElemsHtml from "./parse-elem-html";

const module = {
  editorPlugin,
  renderElems: Object.values(renderElem),
  elemsToHtml: Object.values(elemToHtml),
  parseElemsHtml: Object.values(parseElemsHtml),
};

export default module;
